import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

export interface Breadcrumb {
  label: string;
  nextUrl: string;
}

@Injectable({
  providedIn: 'root',
})
export class BreadcrumbService {
  private breadcrumbs = new BehaviorSubject<Breadcrumb[]>([]);
  breadcrumbs$ = this.breadcrumbs.asObservable();

  constructor(private router: Router) {
    this.router.events.subscribe(() => {
      const root = this.router.routerState.snapshot.root;
      const breadcrumbs = this.createBreadcrumbs(root);
      this.breadcrumbs.next(breadcrumbs);
    });
  }

  private createBreadcrumbs(
    route: any,
    url: string = '',
    breadcrumbs: Breadcrumb[] = []
  ): Breadcrumb[] {
    const label = route.data?.breadcrumb;
    const path = route.routeConfig?.path;
    let nextUrl: string = '';
    if (label) {
      nextUrl = `${url}/${path}`;
      const breadcrumb: Breadcrumb = { label, nextUrl };
      breadcrumbs.push(breadcrumb);
    }

    route.children?.forEach((child: any) => {
      this.createBreadcrumbs(child, nextUrl, breadcrumbs);
    });

    return breadcrumbs;
  }
}
